export const ON_MENU_CLICK = '@@app/ON_MENU_CLICK';

export const SHARE = '@@app/SHARE';

export const ON_ADD_TO_CART = '@@app/ON_ADD_TO_CART';
